export class FormlySectionUnitOfMeasureMapping {

  unitOfMeasureEntryDocId: string;
  formlyTextboxGuid: string;

  public constructor(init?: Partial<FormlySectionUnitOfMeasureMapping>) {
    Object.assign(this, init);
  }
}
